import { useContext } from "react";
import type { IQuestion } from "pro-features/components/Modals/src/FeedbackSurveyModal";
import { FeedbackSurveyModal } from "pro-features/components/Modals/src/FeedbackSurveyModal";
import AllContexts from "pro-features/pages/workspace/common components/AllContexts";
import { BetaBranchSurveyQuestions } from "app/pages/website-analysis/TrafficAndEngagement/BetaBranch/BetaBranchSurveyQuestions";
import { BetaBranchContext } from "app/pages/website-analysis/TrafficAndEngagement/BetaBranch/BetaBranchContext";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

const BETA__BRANCH_SURVEY_NAME = "BETA Branch Survey";

const BetaBranchFeedbackSurvey = () => {
    const { isBetaBranchFeedbackSurveyOpen, setIsBetaBranchFeedbackSurveyOpen, setIsBetaBranchThankUModalOpen } =
        useContext(BetaBranchContext);
    const closeFeedbackSurveyModal = () => {
        allTrackers.dispatchTrackEvent(
            "webanalysis.beta.branch.opt.in.feedback.form.close",
            "click",
            "webanalysis.beta.branch.opt.in.feedback.form.close",
        );
        setIsBetaBranchFeedbackSurveyOpen(false);
    };
    const onSubmitFeedbackSurveyModal = async (question: IQuestion, answer) => {
        allTrackers.dispatchTrackEvent("Button", "click", "webanalysis/BetaFeedbackForm/Submit");
        setIsBetaBranchFeedbackSurveyOpen(false);
        onNextFeedbackSurveyModal(question, answer);
        setIsBetaBranchThankUModalOpen(true);
    };

    const onNextFeedbackSurveyModal = async (question: IQuestion, answer) => {
        allTrackers.dispatchTrackEvent("Button", "click", `webanalysis/BetaFeedbackForm/Next/${question.id || ""}`);
        const { key } = proNavigator.getParams();
        await PreferencesService.add({
            [`${BETA__BRANCH_SURVEY_NAME}/${key}/${question.id}`]: {
                question: question.title,
                answer,
            },
        });
    };

    return (
        <div>
            <AllContexts linkFn={proNavigator.href.bind(proNavigator)}>
                <FeedbackSurveyModal
                    isOpen={isBetaBranchFeedbackSurveyOpen}
                    onCloseClick={closeFeedbackSurveyModal}
                    onSubmitClick={onSubmitFeedbackSurveyModal}
                    onNextClick={onNextFeedbackSurveyModal}
                    surveyQuestions={BetaBranchSurveyQuestions}
                    surveyName={BETA__BRANCH_SURVEY_NAME}
                    customStyles={{
                        customStyles: {
                            content: {
                                height: "280px",
                                padding: "20px 30px",
                                boxSizing: "content-box",
                                width: "518px",
                            },
                        },
                    }}
                />
            </AllContexts>
        </div>
    );
};

export default BetaBranchFeedbackSurvey;
